/* eslint-disable no-magic-numbers */
export default class HttpStatuses {
  static OK = 200;

  static BAD_REQUEST = 400;

  static UNAUTHORIZED = 401;
}
